import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrgFansChannels = async (orgId) => {
  const url = `/orgs/${orgId}/channels`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getOrgFansChannels
